// src/routes.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Main from './routes/Main/Main';
import Designers from './routes/Designers/Designers';
import DesignerProfile from './routes/DesignerProfile/DesignerProfile';
import Orders from './routes/Orders/Orders';
import Notification from './routes/Notification/Notification';
import Post from './routes/Post/Post';
import OrderNew from './routes/OrderNew/OrderNew';
import OrderEdit from './routes/OrderEdit/OrderEdit';
import OrderAbout from './routes/OrderAbout/OrderAbout';
import Profile from './routes/Profile/Profile';
import Likes from './routes/Likes/Likes';
import Login from './routes/Login/Login';
import Chat from './routes/Chat/Chat';

const AppRouter = () => {
  return (
    <Router basename=''>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/designers" element={<Designers />} />
        <Route path="/designer/profile/:id" element={<DesignerProfile />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/post/:id" element={<Post />} />
        <Route path="/order-new" element={<OrderNew />} />
        <Route path="/order-edit" element={<OrderEdit />} />
        <Route path="/order-about" element={<OrderAbout />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/likes" element={<Likes />} />
        <Route path="/login" element={<Login />} />
        <Route path="/chat/:id?" element={<Chat />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;